// @ts-nocheck
import React, { useState } from 'react';
import { NodeResizeControl } from 'reactflow';
import { Typography, Box, IconButton, Card, Popper, Fade } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { ReactComponent as ExpandIconInverted } from '../../assets/images/ExpandIconInverted.svg';
import { ReactComponent as AddArgumentsIcon } from '../../assets/images/Pipeline/tabler-icon-code-asterix.svg';
import 'reactflow/dist/style.css';
import { ReactComponent as DeleteIcon } from '../../assets/images/DeleteIcon.svg';
import DeleteConfirmModal from '../Common/DeleteConfirmModal';

const controlStyle = {
  background: 'transparent',
  border: 'none',
};

const DetailsToShowOnHover = ({ data, showIcons }) => {
  return (
    <Card
      variant="outlined"
      sx={(_theme) => ({
        borderColor: () => _theme?.palette.other.blue3,
        minWidth: '80px',
        maxWidth: '600px',
        padding: 1,
      })}
    >
      <Box>
        {!showIcons && data?.defective ? (
          <Typography>
            This pipeline has become defective. You can delete this pipeline and
            add it again.
          </Typography>
        ) : null}
      </Box>
    </Card>
  );
};

DetailsToShowOnHover.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]).isRequired,
  showIcons: PropTypes.bool.isRequired,
};
const ParentPipelineNode = ({ data }) => {
  const theme = useTheme();
  const [isHovering, setIsHovering] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const evt = new CustomEvent('DELETE_CONNECTED_PIPELINE_STEP', {
    detail: {
      pipId: data?.pipId,
      executionId: data?.executionId,
      nodeId: data?.nodeId,
    },
  });

  const handleDelete = () => {
    window.dispatchEvent(evt);
  };

  const evtPipelineArgument = new CustomEvent(
    'PIPELINE_ARGUMENT_PARENT_NODE_STEP',
    {
      detail: {
        pipId: data?.pipId,
        nodeId: data?.nodeId,
        executionId: data?.executionId,
      },
    }
  );

  const handleShowPipelineArgumentModal = () => {
    window.dispatchEvent(evtPipelineArgument);
  };

  const showIcons =
    Object.keys(data)?.includes('nodeExecutionResult') || data?.isPreview;

  const handleMouseOver = (e) => {
    setAnchorEl(anchorEl ? null : e.currentTarget);
    setIsHovering(true);
  };

  const handleMouseOut = (e) => {
    setAnchorEl(anchorEl ? null : e.currentTarget);
    setIsHovering(false);
  };

  return (
    <>
      <Box
        sx={(_theme) => ({
          width: '100%',
          height: '30px',
          borderTopLeftRadius: '6px',
          borderTopRightRadius: '6px',
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.other.blue1,
          borderStyle: !showIcons && data?.defective ? 'dashed' : '',
          borderColor:
            !showIcons && data?.defective ? _theme.palette.error?.main : '',
          borderBottom: 0,
          borderWidth: !showIcons && data?.defective ? '1px' : 0,
        })}
      >
        <Box
          ml={0.6}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box display="flex" alignItems="center" gap={2} mt={0.5}>
            <Typography
              variant="body4"
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
              textOverflow="ellipsis"
              noWrap
              color={theme.palette.other.white}
              minWidth="100px"
              width={data?.size?.width}
              title={`${data?.label}\nExecution ID: (${data?.executionId})`}
            >
              {`${data?.label}\n(${data?.executionId})`}
            </Typography>
          </Box>
          <Box display="flex" alignItems="center">
            {!showIcons ? (
              <>
                <Box>
                  <IconButton
                    onClick={() => {
                      handleShowPipelineArgumentModal();
                    }}
                    title="Pipeline level argument"
                    aria-label="Pipeline level argument"
                    color="secondary"
                    size="small"
                  >
                    <AddArgumentsIcon
                      height={17}
                      width={17}
                      aria-label="Pipeline level argument"
                      color={theme.palette.other.blue2}
                    />
                  </IconButton>
                </Box>
                <Box>
                  <IconButton
                    color="primary"
                    size="small"
                    onClick={() => setShowDeleteModal(true)}
                    title="Delete connected pipeline"
                    aria-label="Delete connected pipeline"
                  >
                    <DeleteIcon
                      height={17}
                      width={17}
                      color={theme.palette.other.blue2}
                    />
                  </IconButton>
                </Box>
              </>
            ) : null}
          </Box>
        </Box>
      </Box>
      <Box
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
        sx={(_theme) => ({
          width: '100%',
          height: '100%',
          margin: 0,
          padding: 0.5,
          backgroundColor: _theme.palette.other.blue2,
          display: 'flex',
          flexGrow: 1,
          borderRadius: '6px',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderStyle: !showIcons && data?.defective ? 'dashed' : '',
          borderColor:
            !showIcons && data?.defective ? _theme.palette.error?.main : '',
          borderWidth: !showIcons && data?.defective ? '1px' : 0,
          borderTop: 0,
        })}
      >
        {!showIcons ? (
          <NodeResizeControl
            isVisible={true}
            width="100%"
            height="100%"
            minWidth={data?.size?.width < 100 ? 140 : data?.size?.width}
            minheight={data?.size?.height}
            style={controlStyle}
          >
            <ExpandIconInverted
              style={{
                position: 'fixed',
                right: 5,
                bottom: -25,
              }}
            />
          </NodeResizeControl>
        ) : null}
      </Box>
      <DeleteConfirmModal
        open={showDeleteModal}
        onCloseClick={() => setShowDeleteModal(false)}
        onDeleteClick={handleDelete}
        confirmationMsg={`Are you sure you want to remove connection with  ${data?.label} ?`}
        resourceName="pipeline connection"
      />
      {!showIcons && data?.defective ? (
        <Popper
          open={isHovering}
          anchorEl={anchorEl}
          transition
          placement="bottom-start"
        >
          {({ TransitionProps }) => (
            <Fade {...TransitionProps} timeout={350}>
              <Box mt={0.5}>
                <DetailsToShowOnHover data={data} />
              </Box>
            </Fade>
          )}
        </Popper>
      ) : null}
    </>
  );
};

ParentPipelineNode.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]).isRequired,
};
export default ParentPipelineNode;
